<template>
  <base-layout>
    <div class="common-page my-groups">
      <div class="container-fluid">
        <h1 class="common-page__main-title">{{ $t('myGroups') }}</h1>
        <dx-spinner :active="loading" />
        <div class="row" v-if="!loading">
          <div class="col-md-6" v-for="gameGroup in gameGroups" :key="gameGroup.id">
            <dx-game-group
              :owner="isOwner(gameGroup)"
              :group="gameGroup"
              />
          </div>
          <div class="col-md-6">
            <dx-game-group
              @created-game-group="load"
              :owner="true"
              :group="{ id: null, players: [] }"
              />
          </div>
        </div>
      </div>
    </div>
  </base-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { BaseLayout } from '../layouts'
import {
  DxSpinner,
  DxGameGroup
} from '../components'
export default {
  name: 'my-groups',
  components: {
    BaseLayout,
    DxSpinner,
    DxGameGroup
  },
  data () {
    return {
      loading: true
    }
  },
  methods: {
    ...mapActions([
      'loadGameGroups'
    ]),
    load () {
      this.loading = true
      this.loadGameGroups().then(() => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    onEdit (group) {
      this.$router.push({ name: 'editGroup', params: { id: group.id } })
    },
    isOwner (group) {
      let owner = group.players.filter(i => i.state === 'owner')[0]
      if (owner) {
        return this.user.id === owner.id
      }
    }
  },
  computed: {
    ...mapGetters({
      gameGroups: 'getValidGameGroups',
      user: 'getUser'
    })
  },
  created () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/MyGroups.vue